


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { ModalType } from './Modal.models';

@Component({})
export default class Modal extends Vue {
  @Prop({ default: ModalType.Dialog }) private type!: ModalType;
  @Prop({ default: true }) private closeBtn!: boolean;
  @Prop({ default: false }) public withoutScrollbar!: boolean;

  @Emit()
  private closeModal() {
    return;
  }
}
